export const environment = {
  production: '_@_production_@_',
  baseApiUrl: '_@_baseApiUrl_@_',
  appUrl: '_@_appUrl_@_',
  pageSize: 20,
  AzureConfiguration: '_@_AzureConfiguration_@_',
  AzureConfigurationLabel: '_@_AzureConfigurationLabel_@_',
  googleMapsApiKey: '_@_googleMapsApiKey_@_',
  gTag_Id: '_@_gTag_Id_@_',
  connectionString: '_@_connectionString_@_',
  scope: '_@_scope_@_',
  grantType: '_@_grantType_@_',
  clientId: '_@_clientId_@_',
  clientSecret : "_@_clientSecret_@_",
  version: '_@_version_@_',
}; 
